import React, { useState } from 'react';
import { t } from '../../i18n';
import { Link, useNavigate } from 'react-router-dom';
import api from '../../api';
import { APP_LOGO, APP_LOGO_ALT } from '../../config/brand';

function RegisterPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (!form.username || !form.password) {
      setError(t('register_error_required'));
      return;
    }
    if (form.password.length < 6) {
      setError(t('register_error_password_length'));
      return;
    }
    setLoading(true);
    try {
      await api.post('users/register', {
        username: form.username,
        password: form.password,
        tenantId: 'default'
      });
      setSuccess(t('register_success'));
      navigate('/login');
    } catch (err) {
      let msg = t('register_error_failed');
      if (err.response && err.response.data) {
        if (typeof err.response.data === 'string') {
          msg = err.response.data;
        } else if (err.response.data.error) {
          msg = err.response.data.error;
        } else if (err.response.data.message) {
          msg = err.response.data.message;
        }
      } else if (err.message) {
        msg = err.message;
      }
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  const inputClass =
    'w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-600 focus:border-green-600';

  return (
    <div className="h-screen overflow-hidden min-w-[320px] flex items-center justify-center bg-stone-50 px-0 sm:px-4">
      <div className="w-full max-w-md mx-auto">
        <div className="bg-white rounded-none sm:rounded-lg shadow-none sm:shadow-sm px-5 py-5 sm:px-6 sm:py-6 border-0 sm:border sm:border-gray-200 relative">
          <div className="text-center mb-4">
            <div className="flex flex-col items-center justify-center mb-1.5">
              <img
                src={APP_LOGO}
                alt={APP_LOGO_ALT}
                className="h-10 sm:h-12 w-auto object-contain mb-1.5"
              />
              <h1 className="text-lg sm:text-xl font-semibold text-gray-900 tracking-tight">
                {t('systemName')}
              </h1>
            </div>
            <p className="text-gray-500 text-xs">{t('register_title')}</p>
          </div>

          <p className="text-xs text-gray-500 mb-3 text-center leading-relaxed">
            {t('register_subtitle')}
          </p>

          <form onSubmit={handleSubmit} className="space-y-3">
            <div>
              <label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-1">
                {t('login_username_label')}
              </label>
              <input
                id="username"
                name="username"
                value={form.username}
                onChange={handleChange}
                placeholder={t('register_username_placeholder')}
                className={inputClass}
                required
              />
            </div>
            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
                {t('login_password_label')}
              </label>
              <input
                id="password"
                name="password"
                type="password"
                value={form.password}
                onChange={handleChange}
                placeholder={t('register_password_placeholder')}
                className={inputClass}
                required
              />
            </div>

            {error && (
              <div className="text-red-600 text-xs bg-red-50 border border-red-200 rounded-md p-2">
                {error}
              </div>
            )}
            {success && (
              <div className="text-green-700 text-xs bg-green-50 border border-green-200 rounded-md p-2">
                {success}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-green-700 text-white py-2.5 px-4 rounded-md hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-offset-2 disabled:opacity-60 disabled:cursor-not-allowed transition-colors"
            >
              {loading ? t('register_submitting') : t('register_button')}
            </button>
          </form>

          <div className="mt-4 text-center">
            <Link
              to="/login"
              className="text-green-700 hover:text-green-900 hover:underline text-xs transition-colors"
            >
              {t('register_to_login')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RegisterPage;
